import { Controller } from "react-hook-form";
import type { ControlledFieldProps } from "@/components/features/FormBuilder/components/Wrappers/types";
import { TextArea } from "@/components/ui/TextArea/TextArea";

export function ControlledTextArea({
  name,
  control,
  error,
  clearErrors,
  placeholder,
  size = "small",
}: ControlledFieldProps & { placeholder?: string; size?: "small" | "large" }) {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field }) => (
        <TextArea
          value={field.value || ""}
          onChange={(val) => {
            field.onChange(val);
            clearErrors(name);
          }}
          placeholder={placeholder || "Enter..."}
          size={size}
          error={error || false}
        />
      )}
    />
  );
}
